import { useEffect, useState } from "react";
import { Oval } from "react-loader-spinner";
import { useSelector } from "react-redux";
import tickImage from "../assets/images/double-tick.png";
import noteImage from "../assets/images/notes.png";
import plusImage from "../assets/images/plus.png";
import { useAddTodoMutation, useGetCompletedTodosQuery, useGetInCompletedTodosQuery } from "../features/api/apiSlice";

export default function Header() {
    const { inCompleteFilter: colors, completeFilter } = useSelector((state) => state.filter);
    const [handleAddTodo, { isError, isLoading, isSuccess }] = useAddTodoMutation();
    const { data: inCompletedTodos, isError: getError, isLoading: getLoading, refetch } = useGetInCompletedTodosQuery(colors);
    const { refetch: refetchCompletedTodos } = useGetCompletedTodosQuery(completeFilter);

    const [input, setInput] = useState("");

    const handleInput = (e) => {
        setInput(e.target.value);
    };

    const submitHandler = (e) => {
        e.preventDefault();
        if (!isLoading) handleAddTodo({
            text: input,
            completed: false,
        });
    };

    const completeHandler = () => {
        if (!getError && !getLoading && inCompletedTodos?.length > 0) {
            completeAllTasks();
        }
    };

    async function completeAllTasks() {
        console.log("ok");
        let promises = [];
        inCompletedTodos.forEach(todo => {
            console.log(todo);
            const promise = fetch(`https://video-server-ar.herokuapp.com/todos/${todo.id}`, {
                method: "PUT",
                body: JSON.stringify({ ...todo, completed: true }),
                headers: {
                    'Content-Type': 'application/json',
                    
                }
            });
            promises.push(promise);
        });
        await Promise.all(promises);
        refetch();
        refetchCompletedTodos();
    }

    useEffect(() => {
        if (isSuccess) {
            // clearInput
            setInput("");
        }
    }, [isSuccess])

    return (
        <div>
            <form
                className="flex items-center bg-gray-100 px-4 py-4 rounded-md"
                onSubmit={submitHandler}
            >
                <img src={noteImage} className="w-6 h-6" alt="Add todo" />
                <input
                    type="text"
                    placeholder="Type your todo"
                    className={`w-full text-lg px-4 py-1 border-none outline-none bg-gray-100 ${isError ? "text-red-500" : "text-gray-500"}`}
                    value={input}
                    onChange={handleInput}
                    disabled={isLoading}
                />
                {isLoading ? <Oval
                    height={31}
                    width={31}
                    color="#4fa94d"
                    wrapperStyle={{}}
                    wrapperClass=""
                    visible={true}
                    ariaLabel='oval-loading'
                    secondaryColor="#4fa94d"
                    strokeWidth={2}
                    strokeWidthSecondary={2}

                /> :
                    <button
                        type="submit"
                        className={`appearance-none w-8 h-8 bg-[url('${plusImage}')] bg-no-repeat bg-contain`}
                    ></button>
                }
            </form>

            <ul className="flex justify-between my-4 text-xs text-gray-500">
                <li
                    className="flex space-x-1 cursor-pointer"
                    onClick={completeHandler}
                >
                    <img className="w-4 h-4" src={tickImage} alt="Complete" />
                    <span>Complete All Tasks</span>
                </li>
            </ul>
        </div>
    );
}
